import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import RideApi from "Services/Ride";

const RideDeleteModal = ({ openDialog, rideId, handleClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();

  const handleDeleteRide = () => {
    if (!rideId) {
      dispatch(
        showSnackbar({
          message: "Ride ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));

    const onSuccess = () => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Ride Deleted Successfully",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "success",
        })
      );
      handleClose(true);
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting ride",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };

    RideApi.deleteRide(rideId).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={openDialog}
      onClose={() => handleClose(false)}
      aria-labelledby="ride-delete-dialog-title"
    >
      <DialogTitle id="ride-delete-dialog-title">{"Are you sure delete this ride ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Ride ID: {rideId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => handleClose(false)}>
          Disagree
        </Button>
        <Button onClick={handleDeleteRide} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RideDeleteModal;
